export default "__VITE_ASSET__DFE$kFEV__"